export default __webpack_public_path__ + "img/61428e062ebc16de58f6675949dc573e.svg";